const red14ptBold = 'color: red; font-size: 14pt; font-weight: bold'
const blue14ptBold = 'color: blue; font-size: 14pt; font-weight: bold'
const green14ptBold = 'color: green; font-size: 14pt; font-weight: bold'
const magenta14ptBold = 'color: magenta; font-size: 14pt; font-weight: bold'

const red12ptBold = 'color: red; font-size: 12pt; font-weight: bold'
const blue12ptBold = 'color: blue; font-size: 12pt; font-weight: bold'
const green12ptBold = 'color: green; font-size: 12pt; font-weight: bold'
const magenta12ptBold = 'color: magenta; font-size: 12pt; font-weight: bold'

const red11ptBold = 'color: red; font-size: 11pt; font-weight: bold'
const blue11ptBold = 'color: blue; font-size: 11pt; font-weight: bold'
const green11ptBold = 'color: green; font-size: 11pt; font-weight: bold'
const magenta11ptBold = 'color: magenta; font-size: 11pt; font-weight: bold'

const red10ptBold = 'color: red; font-size: 10pt; font-weight: bold'
const blue10ptBold = 'color: blue; font-size: 10pt; font-weight: bold'
const green10ptBold = 'color: green; font-size: 10pt; font-weight: bold'
const magenta10ptBold = 'color: magenta; font-size: 10pt; font-weight: bold'

const logConstants = {
    red14ptBold,
    blue14ptBold,
    green14ptBold,
    magenta14ptBold,

    red12ptBold,
    blue12ptBold,
    green12ptBold,
    magenta12ptBold,

    red11ptBold,
    blue11ptBold,
    green11ptBold,
    magenta11ptBold,

    red10ptBold,
    blue10ptBold,
    green10ptBold,
    magenta10ptBold,
}

export default logConstants